import { socialPlatforms } from '@app/modules/social-export/domain/platforms';

/**
 * Resolves API platform enum string (e.g. YOUTUBE) to the same display name used in social-export UI.
 */
export function getSocialPlatformDisplayName(platformKey: string): string {
  const match = socialPlatforms.all().find((p) => p.id.toLowerCase() === platformKey.toLowerCase());
  return match?.name ?? platformKey;
}
